/* tslint:disable */
/* eslint-disable */
/**
 * referral-network
 * referral-network
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DirectoryContact
 */
export interface DirectoryContact {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    position?: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    phone?: string;
}

/**
 * Check if a given object implements the DirectoryContact interface.
 */
export function instanceOfDirectoryContact(value: object): value is DirectoryContact {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DirectoryContactFromJSON(json: any): DirectoryContact {
    return DirectoryContactFromJSONTyped(json, false);
}

export function DirectoryContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectoryContact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'position': json['position'] == null ? undefined : json['position'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function DirectoryContactToJSON(json: any): DirectoryContact {
    return DirectoryContactToJSONTyped(json, false);
}

export function DirectoryContactToJSONTyped(value?: DirectoryContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'position': value['position'],
        'email': value['email'],
        'phone': value['phone'],
    };
}

